/* FF FINDER (2026-08-10) — vanilla JS, no dependencies.
   Drives both the desktop select bar and the mobile CTA + bottom sheet rendered
   by snippets/ff-finder.liquid. See that file's header comment for the filter
   param / live-count design notes.

   FF POLISH (2026-08-10) [item 2, instant apply]: desktop selects now filter the
   grid IMMEDIATELY on change -- same section-rendering mechanism the facet
   sidebar (assets/facets.min.js, class FacetFiltersForm) uses: fetch
   `?section_id=main-collection-product-grid&<params>`, swap the innerHTML of
   #ProductGridContainer with the response's #ProductGridContainer, and keep
   history in sync via history.pushState so back/forward and sharing work. We
   don't call FacetFiltersForm directly (script-load-order between ff-finder.js
   and facets.min.js isn't guaranteed, and ff-finder's controls aren't inside a
   <facet-filters-form> element) -- instead we replicate the same DOM contract
   (#ProductGridContainer id, section_id query param) and drive our own
   popstate listener so this works even on a page where facets.min.js hasn't
   finished registering its listener yet. The green "Show" button remains as a
   reassurance CTA: it now shows the live "Showing N ->" count and, on click,
   just scrolls to the grid (filtering already happened on change) -- it no
   longer navigates. The mobile bottom sheet is UNCHANGED: two-step, "Show N
   ->" still navigates on click (instant-apply inside a sheet feels jumpy).
*/
(function () {
  'use strict';

  /* FF WAVE 4 (2026-08-12) [ff-finder-section-instance]: owner report — applying
     finder filters re-rendered the grid with SMALLER card images than the
     initial page. Root cause: this file hardcoded the section FILE id
     ('main-collection-product-grid') in its Section Rendering fetches, which
     Shopify renders with the section's SCHEMA DEFAULTS — not the template
     instance's configured settings. On sectional-sofas the default render sets
     filter_type != 'vertical', so the fetched .collection div carries an extra
     `page-width` class NESTED inside the page's real page-width wrapper
     (.facets-vertical) — double width-capping, 1369px -> 1100px container,
     336px -> 269px cards (measured 2026-08-12 at 1920px). Fix: init() derives
     the REAL template-instance id (e.g. 'template--…__product-grid') from the
     grid's own .shopify-section wrapper — the same id facets.js uses — so
     filtered re-renders are class-identical to the initial page. The file id
     below is only the fallback if the wrapper is ever missing. */
  var SECTION_ID = 'main-collection-product-grid';
  var DEBOUNCE_MS = 350; // mobile sheet count-preview debounce (unchanged)
  var INSTANT_APPLY_DEBOUNCE_MS = 250; // desktop instant-apply debounce (spec: 250ms)

  /* FF GENERALISE (2026-08-13, wip210): was a hardcoded 5-param array (shape/
     size_tier/color_family/price gte/lte) that only ever matched
     sectional-sofas' own facets -- adding Coffee Tables' material/features
     params would have silently gone stale (a changed facet's old param would
     linger in the URL instead of being cleared, see buildMergedSearchParams
     below). Replaced with a runtime scan of every data-ff-param actually
     present in the currently-rendered finder (desktop selects + mobile pill
     groups), so this list is correct for whichever collection's finder is on
     the page with zero JS changes needed per category -- same "config
     change, not a code change" goal as snippets/ff-finder.liquid. Computed
     once in init(); see collectFinderParamKeys(). */
  var FINDER_PARAM_KEYS = ['filter.v.price.gte', 'filter.v.price.lte'];

  function collectFinderParamKeys() {
    var keys = ['filter.v.price.gte', 'filter.v.price.lte'];
    var withParam = document.querySelectorAll('[data-ff-param]');
    for (var i = 0; i < withParam.length; i++) {
      var p = withParam[i].getAttribute('data-ff-param');
      if (p && keys.indexOf(p) === -1) { keys.push(p); }
    }
    return keys;
  }

  /* FF GENERALISE (2026-08-13, wip210): a "range" control (today: Budget) is
     identified by its options/pills carrying data-gte/data-lte -- NOT by a
     hardcoded groupName === 'budget' check, which broke as soon as a second
     collection's config used a different id for its price control (it
     doesn't today -- Coffee Tables has no range facet at all -- but this was
     the same class of bug as the FINDER_PARAM_KEYS one above, so fixed here
     too rather than leaving a hardcoded name that could be forgotten by
     whoever adds the next category's price facet). */
  function groupIsRange(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-gte') || items[i].getAttribute('data-lte')) { return true; }
    }
    return false;
  }

  function debounce(fn, ms) {
    var t = null;
    return function () {
      var args = arguments;
      var ctx = this;
      if (t) { clearTimeout(t); }
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  // Reads the current selection state from either a desktop <select> bar or a
  // mobile pill-group sheet and returns a URL query string (no leading '?').
  function buildQuery(root) {
    var parts = [];

    // Desktop: <select data-ff-group> elements.
    var selects = root.querySelectorAll('select[data-ff-group]');
    for (var i = 0; i < selects.length; i++) {
      appendGroupValue(parts, selects[i].getAttribute('data-ff-group'), selects[i].getAttribute('data-ff-param'), selects[i].options[selects[i].selectedIndex]);
    }

    // Mobile: pill groups, one .is-selected button per group.
    var groups = root.querySelectorAll('[data-ff-pillgroup]');
    for (var j = 0; j < groups.length; j++) {
      var group = groups[j];
      var selected = group.querySelector('[data-ff-pill].is-selected');
      if (selected) {
        appendGroupValue(parts, group.getAttribute('data-ff-pillgroup'), group.getAttribute('data-ff-param'), selected);
      }
    }

    return parts.join('&');
  }

  // `optionOrButton` is either an <option> or a pill <button> — both carry
  // data-value/value + optional data-gte/data-lte attributes.
  function appendGroupValue(parts, groupName, param, optionOrButton) {
    if (!optionOrButton) { return; }
    var value = optionOrButton.tagName === 'OPTION' ? optionOrButton.value : optionOrButton.getAttribute('data-value');
    var gte = optionOrButton.getAttribute('data-gte');
    var lte = optionOrButton.getAttribute('data-lte');

    /* FF GENERALISE (2026-08-13, wip210): was `if (groupName === 'budget')`.
       Any control whose SELECTED option/pill carries data-gte/data-lte is a
       price-range control, regardless of its group id -- see groupIsRange()
       above for the matching generalisation in syncFromURL(). A range
       control's <select>/pillgroup never gets a data-ff-param attribute
       (see snippets/ff-finder.liquid: `if q_param != blank` guards it), so
       falling through to the `param` branch below for a range control's
       "Any" option (no gte/lte, value="") is already a no-op either way. */
    if (gte || lte) {
      if (gte) { parts.push('filter.v.price.gte=' + encodeURIComponent(gte)); }
      if (lte) { parts.push('filter.v.price.lte=' + encodeURIComponent(lte)); }
      return;
    }

    if (value && param) {
      /* FF lane1k (2026-09-30): an option value may list several stored values joined by '||'
         (e.g. a cabinet bed sold in two sizes). Each becomes its own param, which Search &
         Discovery ORs together. A value without '||' behaves exactly as before. */
      var ffVals = String(value).split('||');
      for (var fv = 0; fv < ffVals.length; fv++) {
        if (ffVals[fv]) { parts.push(param + '=' + encodeURIComponent(ffVals[fv])); }
      }
    }
  }

  // Pre-select the desktop <select> / mobile pills to match whatever filter.*
  // params are already on the URL, so after a Show-navigation the finder reflects
  // the filters that are actually active instead of silently resetting to "Any".
  function syncFromURL(root) {
    var search = new URLSearchParams(window.location.search);

    var selects = root.querySelectorAll('select[data-ff-group]');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      if (groupIsRange(sel.options)) {
        syncRangeControl(sel.options, search);
        continue;
      }
      var param = sel.getAttribute('data-ff-param');
      var urlVal = param ? search.get(param) : null;
      if (param && search.getAll(param).length > 1) { /* FF lane1k: '||' multi-value options */
        var ffJoined = search.getAll(param).join('||');
        for (var fo = 0; fo < sel.options.length; fo++) { if (sel.options[fo].value === ffJoined) { urlVal = ffJoined; break; } }
      }
      /* FF FIX (2026-08-10) [item 2, back-button correctness]: previously this
         only ever SET a value when the param was present, never reset it back
         to "Any" when the param was absent. That was harmless when every
         render came fresh from the server (the <option selected> already
         matched), but now that popstate re-syncs the SAME live DOM in place
         (see applyParams' popstate handler in initDesktopBar), a control the
         shopper had set now needs to be explicitly cleared back to "" when
         the restored URL no longer carries its param -- otherwise the finder
         bar silently disagrees with the grid it just re-rendered to. */
      sel.value = urlVal || '';
    }

    var groups = root.querySelectorAll('[data-ff-pillgroup]');
    for (var j = 0; j < groups.length; j++) {
      var g = groups[j];
      var pills = g.querySelectorAll('[data-ff-pill]');
      var matched = null;
      if (groupIsRange(pills)) {
        matched = matchRangePill(pills, search);
      } else {
        var gParam = g.getAttribute('data-ff-param');
        var gUrlVal = gParam ? search.get(gParam) : null;
        if (gParam && search.getAll(gParam).length > 1) { /* FF lane1k: '||' multi-value options */
          var ffGJoined = search.getAll(gParam).join('||');
          for (var fp = 0; fp < pills.length; fp++) { if (pills[fp].getAttribute('data-value') === ffGJoined) { gUrlVal = ffGJoined; break; } }
        }
        if (gUrlVal) {
          for (var p = 0; p < pills.length; p++) {
            if (pills[p].getAttribute('data-value') === gUrlVal) { matched = pills[p]; break; }
          }
        }
      }
      // Same fix as the desktop selects above: fall back to the group's
      // "Any" pill (data-value="") when nothing in the URL matches, instead
      // of leaving whatever was previously .is-selected in place.
      if (!matched) {
        for (var q = 0; q < pills.length; q++) {
          if (pills[q].getAttribute('data-value') === '') { matched = pills[q]; break; }
        }
      }
      if (matched) {
        for (var k = 0; k < pills.length; k++) { pills[k].classList.remove('is-selected'); }
        matched.classList.add('is-selected');
      }
    }
  }

  function matchRangePill(pills, search) {
    var gte = search.get('filter.v.price.gte');
    var lte = search.get('filter.v.price.lte');
    if (!gte && !lte) { return null; }
    for (var i = 0; i < pills.length; i++) {
      var pGte = pills[i].getAttribute('data-gte');
      var pLte = pills[i].getAttribute('data-lte');
      if ((pGte || null) === (gte || null) && (pLte || null) === (lte || null)) { return pills[i]; }
    }
    return null;
  }

  function syncRangeControl(options, search) {
    var gte = search.get('filter.v.price.gte');
    var lte = search.get('filter.v.price.lte');
    if (!gte && !lte) { return; }
    for (var i = 0; i < options.length; i++) {
      var oGte = options[i].getAttribute('data-gte');
      var oLte = options[i].getAttribute('data-lte');
      if ((oGte || null) === (gte || null) && (oLte || null) === (lte || null)) {
        options[i].selected = true;
        return;
      }
    }
  }

  /* FF POLISH (2026-08-10) [item 2]: desktop button label default text
     ("Showing N ->") is set from the liquid markup using the real initial
     paginate count (see initDesktopBar's initial-count read below), then kept
     live on every instant-apply fetch. Mobile sheet button keeps the older
     "Show ->" / "Show N ->" plain-count pattern (no filtering has happened
     yet when the sheet opens). If a count fetch ever fails, fall back to a
     plain label (no stale/wrong number) rather than showing 0 or garbage. */
  function setShowLabel(btn, n, prefix) {
    if (!btn) { return; }
    var word = prefix || 'Show';
    if (n === null || n === undefined) {
      btn.textContent = word + ' →';
    } else {
      btn.textContent = word + ' ' + n + ' →';
    }
  }

  /* FF POLISH (2026-08-10) [item 1, black button]: desktop-only label for the black
     "See N matches" / "See all N" button -- kept separate from setShowLabel above
     (which the mobile bottom-sheet's "Show N ->" button still uses unchanged) so the
     mobile sheet's copy/behaviour is untouched. hasSelection is true when at least one
     finder control (select or pill) currently holds a non-"Any" value -- see the
     buildQuery(wrap) !== '' checks at each call site below. */
  function setDesktopShowLabel(btn, n, hasSelection) {
    if (!btn) { return; }
    if (n === null || n === undefined) {
      btn.textContent = hasSelection ? 'See matches →' : 'See all →';
      return;
    }
    btn.textContent = hasSelection ? ('See ' + n + ' matches →') : ('See all ' + n + ' →');
  }

  // Builds the full merged query string for an instant-apply / popstate fetch:
  // start from whatever is already on the URL (sort_by, sidebar facet filters,
  // etc.), strip the finder's own params + pagination, then layer the finder's
  // CURRENT selections back on top. Keeps sidebar-facet and sort state intact.
  function buildMergedSearchParams(root) {
    var current = new URLSearchParams(window.location.search);
    current.delete('page');
    for (var i = 0; i < FINDER_PARAM_KEYS.length; i++) {
      current.delete(FINDER_PARAM_KEYS[i]);
    }
    var finderQuery = buildQuery(root);
    if (finderQuery) {
      var pairs = finderQuery.split('&');
      for (var j = 0; j < pairs.length; j++) {
        var eq = pairs[j].indexOf('=');
        var k = decodeURIComponent(pairs[j].slice(0, eq));
        var v = decodeURIComponent(pairs[j].slice(eq + 1));
        current.append(k, v); /* FF lane1k: append (finder keys were deleted above) so '||' multi-values survive */
      }
    }
    return current.toString();
  }

  // Swaps #ProductGridContainer's contents for the ones in `html` (a fetched
  // section_id=main-collection-product-grid response) -- same technique as
  // FacetFiltersForm.renderProductGridContainer in assets/facets.min.js.
  function renderGridFromHTML(html) {
    var live = document.getElementById('ProductGridContainer');
    if (!live) { return null; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('ProductGridContainer');
    if (fresh) { live.innerHTML = fresh.innerHTML; }
    var m = html.match(/ff-finder-count:(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function setGridLoading(loading) {
    var live = document.getElementById('ProductGridContainer');
    var collectionEl = live && live.querySelector('.collection');
    if (collectionEl) { collectionEl.classList.toggle('loading', loading); }
  }

  var applyRequestToken = 0;

  // Fetches the grid for `searchParams` and applies it to the DOM + button +
  // (optionally) history. Shared by instant-apply (on change) and popstate
  // (on back/forward).
  function applyParams(collectionUrl, searchParams, showBtn, pushHistory, hasSelection) {
    var myToken = ++applyRequestToken;
    setGridLoading(true);
    var sep = searchParams ? (searchParams + '&') : '';
    var url = collectionUrl + '?' + sep + 'section_id=' + SECTION_ID;

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) { throw new Error('ff-finder: bad response ' + res.status); }
        return res.text();
      })
      .then(function (html) {
        if (myToken !== applyRequestToken) { return; } // stale, a newer change superseded this
        var n = renderGridFromHTML(html);
        setGridLoading(false);
        setDesktopShowLabel(showBtn, n, hasSelection);
        if (pushHistory) {
          var qs = searchParams ? ('?' + searchParams) : '';
          history.pushState({ ffFinder: true, searchParams: searchParams }, '', window.location.pathname + qs + window.location.hash);
        }
      })
      .catch(function () {
        if (myToken !== applyRequestToken) { return; }
        setGridLoading(false);
        setDesktopShowLabel(showBtn, null, hasSelection);
      });
  }

  function fetchCount(collectionUrl, query, callback) {
    var sep = query ? (query + '&') : '';
    var url = collectionUrl + '?' + sep + 'section_id=' + SECTION_ID;

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) { throw new Error('ff-finder: bad response ' + res.status); }
        return res.text();
      })
      .then(function (html) {
        var m = html.match(/ff-finder-count:(\d+)/);
        callback(m ? parseInt(m[1], 10) : null);
      })
      .catch(function () {
        callback(null);
      });
  }

  /* FF POLISH (2026-08-10, wip59) [owner item 2, reset control]: shared by both
     the desktop round button and the mobile sheet's text link -- shows the
     control only once at least one finder value is non-"Any", hides it again
     once everything is back to "Any". */
  function updateResetVisibility(resetBtn, hasSelection) {
    if (!resetBtn) { return; }
    resetBtn.hidden = !hasSelection;
  }

  function resetDesktopSelections(wrap) {
    var selects = wrap.querySelectorAll('select[data-ff-group]');
    for (var i = 0; i < selects.length; i++) {
      selects[i].value = '';
    }
  }

  function resetPillSelections(root) {
    var groups = root.querySelectorAll('[data-ff-pillgroup]');
    for (var j = 0; j < groups.length; j++) {
      var pills = groups[j].querySelectorAll('[data-ff-pill]');
      var anyPill = null;
      for (var p = 0; p < pills.length; p++) {
        pills[p].classList.remove('is-selected');
        if (pills[p].getAttribute('data-value') === '') { anyPill = pills[p]; }
      }
      if (anyPill) { anyPill.classList.add('is-selected'); }
    }
  }

  function initDesktopBar(wrap) {
    var collectionUrl = wrap.getAttribute('data-collection-url');
    var showBtn = wrap.querySelector('[data-ff-show-btn]');
    var resetBtn = wrap.querySelector('[data-ff-reset-btn]');
    var selects = wrap.querySelectorAll('select[data-ff-group]');

    syncFromURL(wrap);
    updateResetVisibility(resetBtn, buildQuery(wrap) !== '');

    /* FF POLISH (2026-08-10) [item 2, instant apply]: initial label reads the
       TRUE current count straight out of the already-rendered page (the
       ff-finder-count marker is inside #ProductGridContainer's own initial
       HTML -- see sections/main-collection-product-grid.liquid) so "Showing N
       ->" is accurate from first paint, matching whatever filters (finder or
       sidebar) were already active in the URL on load -- no extra fetch. */
    var initialGrid = document.getElementById('ProductGridContainer');
    var initialMatch = initialGrid && initialGrid.innerHTML.match(/ff-finder-count:(\d+)/);
    setDesktopShowLabel(showBtn, initialMatch ? parseInt(initialMatch[1], 10) : null, buildQuery(wrap) !== '');

    var applyInstant = debounce(function () {
      var merged = buildMergedSearchParams(wrap);
      applyParams(collectionUrl, merged, showBtn, true, buildQuery(wrap) !== '');
    }, INSTANT_APPLY_DEBOUNCE_MS);

    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', function () {
        // Reset visibility follows the control state immediately (no debounce)
        // even though the grid fetch itself is still debounced below.
        updateResetVisibility(resetBtn, buildQuery(wrap) !== '');
        applyInstant();
      });
    }

    /* FF POLISH (2026-08-10) [item 2, instant apply]: filtering now happens on
       `change` above, live -- the button is reassurance only. Clicking it no
       longer navigates; it just scrolls the (already-filtered) grid into
       view, per spec. */
    if (showBtn) {
      showBtn.addEventListener('click', function () {
        var grid = document.getElementById('ProductGridContainer');
        if (grid) { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }

    /* FF POLISH (2026-08-10, wip59) [owner item 2, reset control]: resets every
       control to "Any", clears the finder's own filter.* params from the URL
       (buildMergedSearchParams still strips+re-layers, but with every control
       now "Any" it contributes nothing back -- sidebar-facet/sort params on the
       URL are untouched, same as any other instant-apply), re-fetches + renders
       the grid, and hides itself again. */
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        resetDesktopSelections(wrap);
        updateResetVisibility(resetBtn, false);
        var merged = buildMergedSearchParams(wrap);
        applyParams(collectionUrl, merged, showBtn, true, false);
      });
    }

    /* Back/forward support: on popstate, re-fetch + re-render the grid for
       whatever params are now on the URL, and re-sync the selects to match
       (so the finder bar itself reflects the restored filter state too). We
       drive this ourselves (rather than depending on assets/facets.min.js's
       own popstate listener) since ff-finder's controls live outside any
       <facet-filters-form> and script load/registration order between the
       two files isn't guaranteed. */
    window.addEventListener('popstate', function (event) {
      var state = event.state;
      var params = (state && typeof state.searchParams === 'string')
        ? state.searchParams
        : window.location.search.replace(/^\?/, '');
      syncFromURL(wrap);
      updateResetVisibility(resetBtn, buildQuery(wrap) !== '');
      applyParams(collectionUrl, params, showBtn, false, buildQuery(wrap) !== '');
    });
  }

  function lockScroll(lock) {
    if (lock) {
      document.body.classList.add('ff-finder-scroll-locked');
    } else {
      document.body.classList.remove('ff-finder-scroll-locked');
    }
  }

  function initMobileSheet(mobileWrap, sheet, backdrop) {
    if (!sheet || !backdrop) { return; }
    var collectionUrl = mobileWrap.getAttribute('data-collection-url');
    var openBtn = mobileWrap.querySelector('[data-ff-sheet-open]');
    var closeBtn = sheet.querySelector('[data-ff-sheet-close]');
    var showBtn = sheet.querySelector('[data-ff-show-btn]');
    var resetBtn = sheet.querySelector('[data-ff-reset-btn]');
    var pills = sheet.querySelectorAll('[data-ff-pill]');
    var requestToken = 0;

    syncFromURL(sheet);
    updateResetVisibility(resetBtn, buildQuery(sheet) !== '');

    var runCount = debounce(function () {
      var query = buildQuery(sheet);
      var myToken = ++requestToken;
      fetchCount(collectionUrl, query, function (n) {
        if (myToken !== requestToken) { return; }
        setShowLabel(showBtn, n);
      });
    }, DEBOUNCE_MS);

    function openSheet() {
      backdrop.hidden = false;
      sheet.hidden = false;
      backdrop.classList.add('is-open');
      sheet.classList.add('is-open');
      lockScroll(true);
      /* FF POLISH (2026-08-10) [item 2]: opening the sheet is not itself an
         interaction with a filter -- no runCount() here anymore. The count only
         fetches once the shopper actually taps a pill (see the pill click
         handler below), same "no count until interaction" rule as desktop. */
    }

    function closeSheet() {
      backdrop.classList.remove('is-open');
      sheet.classList.remove('is-open');
      backdrop.hidden = true;
      sheet.hidden = true;
      lockScroll(false);
    }

    if (openBtn) { openBtn.addEventListener('click', openSheet); }
    if (closeBtn) { closeBtn.addEventListener('click', closeSheet); }
    backdrop.addEventListener('click', closeSheet);

    for (var i = 0; i < pills.length; i++) {
      pills[i].addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var group = btn.closest('[data-ff-pillgroup]');
        if (!group) { return; }
        var siblings = group.querySelectorAll('[data-ff-pill]');
        for (var s = 0; s < siblings.length; s++) {
          siblings[s].classList.remove('is-selected');
        }
        btn.classList.add('is-selected');
        updateResetVisibility(resetBtn, buildQuery(sheet) !== '');
        runCount();
      });
    }

    if (showBtn) {
      showBtn.addEventListener('click', function () {
        var query = buildQuery(sheet);
        window.location.href = collectionUrl + (query ? '?' + query : '');
      });
    }

    /* FF POLISH (2026-08-10, wip59) [owner item 2, reset control]: mobile mirror
       of the desktop reset -- the sheet's own filtering is two-step (only ever
       applied to the URL/grid via the "Show" button above), so reset here only
       needs to clear the sheet's pending pill selections back to "Any" and
       refresh the live count preview to match -- no URL/grid to touch until
       "Show" is tapped. */
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        resetPillSelections(sheet);
        updateResetVisibility(resetBtn, false);
        runCount();
      });
    }
  }

  function init() {
    /* FF WAVE 4 [ff-finder-section-instance]: resolve the template-instance
       section id from the live DOM (see the header note on SECTION_ID). The
       wrapper element survives every innerHTML swap, so reading it once here
       is stable across filter re-renders. */
    var gridContainer = document.getElementById('ProductGridContainer');
    var sectionWrap = gridContainer && gridContainer.closest('.shopify-section');
    if (sectionWrap && sectionWrap.id && sectionWrap.id.indexOf('shopify-section-') === 0) {
      SECTION_ID = sectionWrap.id.slice('shopify-section-'.length);
    }

    /* FF GENERALISE (2026-08-13, wip210): resolve the real per-category param
       list from whatever finder markup is actually on the page -- see
       collectFinderParamKeys() above. */
    FINDER_PARAM_KEYS = collectFinderParamKeys();

    var desktopBars = document.querySelectorAll('[data-ff-finder-desktop]');
    for (var i = 0; i < desktopBars.length; i++) {
      initDesktopBar(desktopBars[i]);
    }

    var mobileWraps = document.querySelectorAll('[data-ff-finder-mobile]');
    for (var j = 0; j < mobileWraps.length; j++) {
      var sheet = document.querySelector('[data-ff-sheet]');
      var backdrop = document.querySelector('[data-ff-sheet-backdrop]');
      initMobileSheet(mobileWraps[j], sheet, backdrop);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
